var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "primary-input",
      class: {
        "primary-input--icon": _vm.icon,
        "primary-input--disabled": _vm.disabled,
        "primary-input--focused": _vm.focused,
        "primary-input--error": _vm.error,
        "primary-input--not-empty": _vm.value != "" && _vm.value !== undefined,
        "primary-input--no-float": _vm.noFloat
      }
    },
    [
      _c("textarea", {
        ref: "input",
        staticClass: "input-field textarea",
        class: {
          "input-field--valid": !_vm.error,
          "input-field--invalid": _vm.error,
          "input-field--empty": _vm.value == ""
        },
        attrs: {
          id: _vm.id,
          placeholder: _vm.placeholder,
          required: _vm.required,
          disabled: _vm.disabled,
          readonly: _vm.readonly,
          minlength: _vm.minlength,
          maxlength: _vm.maxlength,
          inputmode: _vm.inputmode,
          pattern: _vm.pattern,
          autocomplete: _vm.autocomplete
        },
        domProps: { value: _vm.value },
        on: {
          input: _vm.onInput,
          focus: _vm.onFocus,
          blur: _vm.onBlur,
          keyup: _vm.onKeyup,
          keydown: _vm.onKeydown
        }
      }),
      _vm._v(" "),
      _vm.label
        ? _c(
            "label",
            {
              staticClass: "input-label",
              class: {
                "label-w-icon": _vm.icon
              },
              attrs: { for: _vm.id }
            },
            [
              _vm.labelOption
                ? _c("span", [
                    _c("span", { domProps: { innerHTML: _vm._s(_vm.label) } }),
                    _vm._v(" "),
                    _c("span", {
                      staticClass: "optional",
                      domProps: { innerHTML: _vm._s(_vm.labelOption) }
                    })
                  ])
                : _c("span", { domProps: { innerHTML: _vm._s(_vm.label) } })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.icon
        ? _c(_vm.iconComponent(_vm.icon), {
            tag: "component",
            staticClass: "primary-input__icon"
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showCharsleft && _vm.maxlength
        ? _c("span", {
            staticClass: "primary-input__charsleft",
            domProps: { innerHTML: _vm._s(_vm.charsLeftText) }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }